class Unidade {
    constructor(id, nome, sigla){
        this.id = id;
        this.nome = nome;
        this.sigla = sigla;
    }
}

export default Unidade;
